import { createFileRoute } from "@tanstack/react-router";
import { WaitlistPage } from "@corpuscomplete/web/modules/auth/pages/waitlist";

export const Route = createFileRoute("/_pending/waitlist")({
  component: WaitlistPage,
});
